/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type AdVehicleStreamServiceCancellationVehicleFragment = {
  __typename?: 'Vehicle'
  id: string
  fccCurrentAdAlerts: {
    __typename?: 'FccAdAlerts'
    alerts: Array<{
      __typename?: 'FccAdAlert'
      id: string
      type: Types.FccAdAlertType
      status: Types.FccAdAlertStatus
      visibleTo: Array<Types.FccOperatorRoleType>
    }>
  } | null
  fccUpcomingWaypoints: Array<{
    __typename?: 'FccWaypoint'
    adState: Types.FccWaypointState | null
    fccStop: {
      __typename?: 'FccStop'
      id: string | null
      names: Partial<Record<'de' | 'en' | 'no', string>>
    } | null
    stopWithServiceArea: {
      __typename?: 'Stop'
      id: string
      serviceArea: { __typename?: 'ServiceArea'; id: string }
    } | null
    actions: Array<
      | {
          __typename: 'FccWaypointDeliveryAction'
          id: string
          estimatedAt: string
          pickedUpAt: string | null
          trip: { __typename?: 'Trip'; id: string } | null
          customer: {
            __typename?: 'Customer'
            firstName: string | null
            lastName: string | null
            extendedWalkingTime: boolean
            visualImpairment: boolean | null
          } | null
          ridePassengerInfo: {
            __typename?: 'FccRidePassengerInfo'
            customerId: string | null
            displayName: string | null
            boardingRequirements: {
              __typename?: 'FccBoardingRequirements'
              headCount: number
              childSeat: boolean
              wheelchair: boolean
            } | null
            impairments: {
              __typename?: 'FccImpairments'
              visual: boolean
            } | null
          } | null
        }
      | { __typename?: 'FccWaypointHubReturnAction' }
      | {
          __typename: 'FccWaypointPickupAction'
          id: string
          estimatedAt: string
          pickedUpAt: string | null
          adPassengerAuthenticationState: Types.FccPassengerAuthenticationState | null
          notShownUpAt: string | null
          tripIsCancelled: boolean | null
          trip: { __typename?: 'Trip'; id: string } | null
          customer: {
            __typename?: 'Customer'
            firstName: string | null
            lastName: string | null
            extendedWalkingTime: boolean
            visualImpairment: boolean | null
          } | null
          ridePassengerInfo: {
            __typename?: 'FccRidePassengerInfo'
            customerId: string | null
            displayName: string | null
            boardingRequirements: {
              __typename?: 'FccBoardingRequirements'
              headCount: number
              childSeat: boolean
              wheelchair: boolean
            } | null
            impairments: {
              __typename?: 'FccImpairments'
              visual: boolean
            } | null
          } | null
        }
      | { __typename?: 'FccWaypointReallocationAction' }
    >
  }> | null
}

export type AdVehicleStreamManageServiceMutationVariables = Types.Exact<{
  input: Types.FccManageServiceInput
}>

export type AdVehicleStreamManageServiceMutation = {
  __typename?: 'Mutation'
  fccManageService: {
    __typename?: 'FccManageServiceResponse'
    sessionId: string
  }
}

export const AdVehicleStreamServiceCancellationVehicleFragmentDoc = gql`
    fragment AdVehicleStreamServiceCancellationVehicle on Vehicle {
  id
  fccCurrentAdAlerts {
    alerts {
      ...UseAlertsForRoleAdAlert
      id
      type
      status
    }
  }
  fccUpcomingWaypoints {
    ...GetPassengersWaypoint
    adState
  }
}
    `
export const AdVehicleStreamManageServiceDocument = gql`
    mutation AdVehicleStreamManageService($input: FccManageServiceInput!) {
  fccManageService(input: $input) {
    sessionId
  }
}
    `
export type AdVehicleStreamManageServiceMutationFn = Apollo.MutationFunction<
  AdVehicleStreamManageServiceMutation,
  AdVehicleStreamManageServiceMutationVariables
>

/**
 * __useAdVehicleStreamManageServiceMutation__
 *
 * To run a mutation, you first call `useAdVehicleStreamManageServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdVehicleStreamManageServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adVehicleStreamManageServiceMutation, { data, loading, error }] = useAdVehicleStreamManageServiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdVehicleStreamManageServiceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdVehicleStreamManageServiceMutation,
    AdVehicleStreamManageServiceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AdVehicleStreamManageServiceMutation,
    AdVehicleStreamManageServiceMutationVariables
  >(AdVehicleStreamManageServiceDocument, options)
}
export type AdVehicleStreamManageServiceMutationHookResult = ReturnType<
  typeof useAdVehicleStreamManageServiceMutation
>
export type AdVehicleStreamManageServiceMutationResult =
  Apollo.MutationResult<AdVehicleStreamManageServiceMutation>
export type AdVehicleStreamManageServiceMutationOptions =
  Apollo.BaseMutationOptions<
    AdVehicleStreamManageServiceMutation,
    AdVehicleStreamManageServiceMutationVariables
  >
